import { getSuggestsQuery } from 'feature/DaData/getSuggestsQuery'
import { TSuggest } from 'feature/registration/types'
import { debounce } from 'helpers/debounce'
import { useSetNotice } from 'hooks/useSetNotice'
import { useState, useCallback } from 'react'
import { Severity } from 'widget/Notifications'

type UseDadataSuggestsOptions = {
  minQueryLength?: number
  onError?: (error: unknown) => void
}

export const useDadataSuggests = (options: UseDadataSuggestsOptions = {}) => {
  const { minQueryLength = 4, onError } = options
  const setNotice = useSetNotice()

  const [suggests, setSuggests] = useState<TSuggest[]>([])
  const [isLoadingSuggest, setIsLoadingSuggest] = useState(false)

  const getSuggests = async (query: string) => {
    if (query.length < minQueryLength) {
      setSuggests([])
      return
    }

    setIsLoadingSuggest(true)
    try {
      const { data } = await getSuggestsQuery(query)
      setSuggests(data || [])
    } catch (err: unknown) {
      if (
        err &&
        typeof err === 'object' &&
        'response' in err &&
        err.response &&
        typeof err.response === 'object' &&
        'status' in err.response &&
        err.response.status === 500
      ) {
        setNotice('Ошибка сервера', Severity.error)
        console.error(err)
      }
      if (onError) {
        onError(err)
      }
    } finally {
      setIsLoadingSuggest(false)
    }
  }

  const debounceGetSuggests = useCallback(debounce(getSuggests, 300), [])

  const clearSuggests = useCallback(() => {
    setSuggests([])
  }, [])

  return {
    suggests,
    isLoadingSuggest,
    getSuggests: debounceGetSuggests,
    clearSuggests,
  }
}
